/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React from 'react';
import { withRouter } from "react-router-dom";

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    Badge,
    Tooltip,
    IconButton,
} from "@material-ui/core";

import EmailIcon from '@material-ui/icons/Email';

/*
 * ---------------------------------------------------------------------
 * import components
 * ---------------------------------------------------------------------
 */
import {
    t
} from "src/shared_modules/i18n";

/*
 * ---------------------------------------------------------------------
 * import action
 * ---------------------------------------------------------------------
 */
import {
    openChat,
    closeChat,
} from "src/shared_modules/veu-visitors-plazz/actions/chat";

import {
    hideAllPopovers,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    hidePageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";

import {
    hideContent
} from "src/shared_modules/veu-visitors-core/actions/content";
/*
 * ---------------------------------------------------------------------
 * class UserSection
 * ---------------------------------------------------------------------
 */
class ChatButton extends React.Component {

    componentDidMount() {
        this.clickChat = this.clickChat.bind(this);
    }

    clickChat() {
        if( (this.props.plazzchat.isOpen && this.props.plazzchat.activeTab !== "conversations")
                || !this.props.plazzchat.isOpen
            ) {
            this.props.hideContent();
            this.props.hidePageGlobal();
            this.props.hideAllPopovers();
            this.props.openChat("conversations");
        } else {
            this.props.closeChat();
        }

        if( this.props.onClick )
            this.props.onClick();
    }

    render() {
        // first fail saves!
        // if no convention is defined or chat nothing to do here
        if( !this.props.event.hasPlazzConvention || !this.props.event.hasPlazzChat)
            return( null );

        let { pathname } = this.props.location;
        let enablePlazzChat = false;

        // if user is on home he has no access to event for any reason so there is no chat!!!!
        if( !pathname.endsWith("home") && !pathname.endsWith("preregister") )
        {
            if( this.props.user.plazz ) {
                enablePlazzChat = this.props.user.loggedIn && this.props.user.plazz.privacy.person_chat;
            }
        }

        if ( !enablePlazzChat )
            return (null);

        // TODO restricted events let evIsPublic = (this.props.event.accesslevel === "public");

        let colorChat = "primary";
        if( this.props.plazzchat.isOpen && this.props.plazzchat.activeTab === "conversations"  )
            colorChat = "secondary";

        let unreadCount = this.props.plazzchat.messageCount;
        let hideMsgDot = !this.props.plazzchat.hasNewMessage;
        let tooltip = "main-nav.chat";
        if( this.props.plazzchat.hasNewMessage ) {
            tooltip = "main-nav.new-messages";
        }
        return (<React.Fragment>
                    <Tooltip title={t(tooltip)}>
                        <IconButton aria-label="chat" onClick={() => this.clickChat()}>
                            <Badge color="secondary" invisible={hideMsgDot} badgeContent={unreadCount} max={99}>
                                <EmailIcon color={colorChat} />
                            </Badge>
                        </IconButton>
                    </Tooltip>
            </React.Fragment>);
    }

}
/*
 * ---------------------------------------------------------------------
 * ChatButton prop Types
 * ---------------------------------------------------------------------
 */
ChatButton.propTypes = {
    user : PropTypes.object,
    event : PropTypes.object,
    plazzchat: PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * ChatButton Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user : state.user,
        event : state.event,
        plazzchat: state.plazz.chat,
        currentLang : state.system.currentLang,
    };
};

const mapDispatchToProps = {
    openChat,
    closeChat,
    hideAllPopovers,
    hideContent,
    hidePageGlobal
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(ChatButton));
